import { z } from 'zod';
import { Languages } from '../constants/languages';
// Schema (source of truth)
export const userPreferencesMobilePreferencesSchema = z.object({
	filters: z.object({
		floorIds: z.array(z.string()).nullable(),
		professionIds: z.array(z.string()).nullable(),
	}),
});

export const userPreferencesSchema = z.object({
	_id: z.string().optional(),
	username: z.string(),
	mobile: userPreferencesMobilePreferencesSchema,
	language: z.enum(Languages).optional(),
});

// Types (derived from schemas)
export type IUserPreferencesMobilePreferences = z.infer<typeof userPreferencesMobilePreferencesSchema>;
export type IUserPreferences = z.infer<typeof userPreferencesSchema>;
